import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { EnvironmentalCondition } from './environmentalCondition.types';

export const environmentalConditionPullQueryBuilder = (document: EnvironmentalCondition) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query areasEnvironmentConditionBySite($site: Int!, $lastRequested: DateTime!) {
      areasEnvironmentConditionBySite(site: $site, lastRequested: $lastRequested) {
        pkAreaRiskResult
        riskCategoryId
        pkAreaRiskCategoryRankType
        riskName
        riskValue
        riskTypeId
        riskTypeName
        areaId
        dateModified
        site
      }
    }
  `);

  return {
    query,
    variables: {
      site: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};
